import Tracker from '@openreplay/tracker';

const OpenreplayTracker = new Tracker({
  projectKey: 'nxl2734vY6cHsE71OT4j',
  // __DISABLE_SECURE_MODE: true,
});
export default OpenreplayTracker;
